import {
  type ForwardedRef,
  forwardRef,
  type InputHTMLAttributes,
  useContext,
} from "react";
import { twMerge } from "tailwind-merge";
import { InputContext } from "./InputContext";
import { generatePlaceholder } from "./utils/generatePlaceholder";

export const InputRoot = forwardRef(
  (
    props: InputHTMLAttributes<HTMLInputElement>,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    const { inputId } = useContext(InputContext);

    return (
      <input
        ref={ref}
        id={inputId}
        {...props}
        className={twMerge(
          "w-full appearance-none bg-transparent text-zinc-900 !caret-zinc-900 outline-hidden outline-0 placeholder:text-zinc-400 disabled:cursor-not-allowed disabled:text-zinc-400 dark:text-zinc-100 dark:!caret-zinc-100 dark:placeholder:text-zinc-500 dark:disabled:text-zinc-500",
          props.className,
        )}
        placeholder={generatePlaceholder(props.placeholder)}
      />
    );
  },
);

InputRoot.displayName = "InputRoot";
